import './Blog.css';
import HeaderBlog from './HeaderBlog';
import blogPosts from './blogData';


const categories = [
  'Toate articolele',
  
  'Conturi',
  'Bilant',
  
];



const Blog = () => {
  const featuredPosts = blogPosts.filter((post) => post.featured);
  const normalPosts = blogPosts.filter((post) => !post.featured);

  return (
    <div className='blog-page'>
      <HeaderBlog />

      <main className='blog-main'>
        <section className='blog-hero'>
          <h1 className='blog-title'>Articole</h1>

          <div className='blog-categories'>
            {categories.map((category, index) => (
              <button
                type='button'
                className={`blog-category ${index === 0 ? 'active' : ''}`}
                key={category}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        <section className='blog-featured-grid'>
          {featuredPosts.map((post) => (
            <article className='blog-card blog-card-large' key={post.title}>
              <a href={post.href} className='blog-card-image-link'>
                <img src={post.image} alt={post.title} className='blog-card-image' />
              </a>

              <div className='blog-card-content'>
                <p className='blog-card-meta'>
                  {post.date} <span>|</span> {post.time}
                </p>

                <h2 className='blog-card-title'>
                  <a href={post.href}>{post.title}</a>
                </h2>

                <a href={post.href} className='blog-card-link'>
                  Mai mult
                </a>
              </div>
            </article>
          ))}
        </section>

        <section className='blog-grid-section'>
          <div className='blog-grid'>
            {normalPosts.map((post) => (
              <article className='blog-card' key={post.title}>
                <a href={post.href} className='blog-card-image-link'>
                  <img src={post.image} alt={post.title} className='blog-card-image' />
                </a>

                <div className='blog-card-content'>
                  <p className='blog-card-meta'>
                    {post.date} <span>|</span> {post.time}
                  </p>

                  <h2 className='blog-card-title'>
                    <a href={post.href}>{post.title}</a>
                  </h2>

                  <a href={post.href} className='blog-card-link'>
                    Mai mult
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
  
    </div>
  );
};

export default Blog;